import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "@/i18n";
// import "@mdi/font/css/materialdesignicons.css";
// import '@/sass/overrides.sass'
// import mdiIcons from "@mdi/js"; // Import all MDI icons from @mdi/js
import "@mdi/font/css/materialdesignicons.min.css"; // Import the Material Design Icons CSS

Vue.use(Vuetify);

const theme = {
  primary: "#35A79D", // ORKO primary teal
  secondary: "#277D74", // ORKO mid teal
  accent: "#58B3A1", // ORKO light teal
  info: "#1D3C37", // ORKO dark teal
  success: "#13DEB9",
  warning: "#FFAE20",
  error: "#FA896B",
};
export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  // icons: {
  //   iconfont: "mdiSvg", // Use mdiSvg as the iconfont type for Vuetify
  //   values: mdiIcons, // Register mdiIcons object (from @mdi/js) with Vuetify
  // },
});
